import { getStringCountryCode } from '@exam-center/alternative-registration';
import { useExamEventDetails } from '@exam-center/exam-event-management';
import { Flex, Loading } from '@shared/components';

import { RegistrationExamDetails, RegistrationInformationDetails } from '../../components';
import { useProctoringRegistrationDetails } from '../../providers';

export default function RegistrationDetailsLogic() {
  const { examEvent } = useExamEventDetails();
  const { examinee, examEventExaminee, loading } = useProctoringRegistrationDetails();

  if (loading) {
    return (
      <Flex
        sx={{
          width: '100%',
          height: 'calc(100dvh - 318px)',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loading />
      </Flex>
    );
  }
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        width: '100%',
      })}
    >
      <RegistrationExamDetails
        slotProps={{
          examCourseName: examEvent.name,
          seatNumber: examEventExaminee.seatNumber,
          roundNumber: examEvent.roundNumber,
          examStartedAt: examEvent.examStartedAt,
          examEndedAt: examEvent.examEndedAt,
          locationName: examEvent.examLocation.nameTh,
          province: examEvent.examLocation.province.nameTh,
          status: examinee.eKycStatus,
        }}
      />
      <RegistrationInformationDetails
        slotProps={{
          examEventExamineeId: examEventExaminee.id,
          registrationStatus: examEventExaminee.registrationStatus,
          examStartedAt: examEvent.examStartedAt,
          name: {
            title: examinee.title,
            firstName: examinee.firstName,
            middleName: examinee.middleName,
            lastName: examinee.lastName,
          },
          document: {
            idNumber: examinee.idNumber,
            idType: examinee.idType,
            registrationType: examEventExaminee.registrationType,
            documentType: examEventExaminee.registrationDocumentType,
          },
          dateOfBirth: examinee.dateOfBirth,
          expiredDate: examinee.expiredDate,
          reason: examEventExaminee.reason,
          countryCode: getStringCountryCode(examinee.countryCode),
        }}
      />
    </Flex>
  );
}
